"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[230],{

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1591);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(282);

var Button = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            '&.MuiButton--transparent': {
                color: theme.palette.primary.contrastText,
                backgroundColor: 'rgba(255, 255, 255, .3)',
                '&:hover, &:focus, &:active, &.selected': {
                    backgroundColor: 'rgba(255, 255, 255, .1)'
                }
            },
            '&.MuiButton--gradient': {
                color: theme.palette.primary.contrastText,
                backgroundColor: 'rgba(255, 255, 255, .1)',
                transition: theme.transitions.create([
                    'transform',
                    'background-size'
                ]),
                background: "linear-gradient(110deg, ".concat(theme.palette.secondary.main, " 0%, ").concat(theme.palette.primary.main, " 100%);"),
                backgroundSize: '100%',
                '&:hover, &:focus, &:active, &.selected': {
                    backgroundSize: '300%'
                }
            },
            '& .MuiCircularProgress-root': {
                position: 'absolute',
                left: '50%',
                top: '50%',
                marginLeft: '-.75em',
                marginTop: '-.75em'
            }
        },
        sizeSmall: {},
        sizeLarge: {},
        contained: {
            color: theme.palette.primary.contrastText
        },
        outlined: {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            backgroundColor: 'transparent'
        },
        outlinedSecondary: {
            color: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main
        },
        containedPrimary: {
            '&:hover, &:focus, &:active, &.selected': {
                backgroundColor: theme.palette.primary.dark
            }
        },
        containedSecondary: {
            color: theme.palette.primary.contrastText,
            '&:hover, &:focus, &:active, &.selected': {
                backgroundColor: theme.palette.secondary.dark
            }
        },
        textPrimary: {
            color: theme.palette.primary.main
        },
        textSecondary: {
            color: theme.palette.secondary.main
        }
    };
})(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 94455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ isPrismicText; },
/* harmony export */   "yz": function() { return /* binding */ prismicText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _prismicio_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92839);
/* harmony import */ var _prismicio_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63064);
/* harmony import */ var _prismicio_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71799);
/* harmony import */ var _utils_htmlSerializer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27915);





var isPrismicText = function(field) {
    var ref;
    if (typeof field === 'string') {
        return field && field.length > 0;
    }
    return field && ((ref = _prismicio_helpers__WEBPACK_IMPORTED_MODULE_3__/* .asText */ .S(field)) === null || ref === void 0 ? void 0 : ref.length) > 0;
};
var prismicText = function(field) {
    var defaultText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    if (typeof field === 'string') {
        return isPrismicText(field) ? field : defaultText;
    }
    return isPrismicText(field) ? _prismicio_helpers__WEBPACK_IMPORTED_MODULE_3__/* .asText */ .S(field) : defaultText;
};
var CMSText = function(param) {
    var data = param.data, _defaultText = param.defaultText, defaultText = _defaultText === void 0 ? '' : _defaultText, _asText = param.asText, asText = _asText === void 0 ? false : _asText;
    if (typeof data === 'string' && data.length > 0) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data
    }));
    else if (isPrismicText(data)) {
        var c = asText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_react__WEBPACK_IMPORTED_MODULE_4__/* .PrismicText */ .K, {
            field: data
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_prismicio_react__WEBPACK_IMPORTED_MODULE_5__/* .PrismicRichText */ .v, {
            field: data,
            components: _utils_htmlSerializer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        });
        return c;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: defaultText
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (CMSText);


/***/ }),

/***/ 59000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextField_TextField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 2 modules
var TextField = __webpack_require__(4073);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Warning.js
var Warning = __webpack_require__(21727);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 16 modules
var react_select_browser_esm = __webpack_require__(52547);
// EXTERNAL MODULE: ./node_modules/react-phone-number-input/min/index.js + 35 modules
var react_phone_number_input_min = __webpack_require__(42682);
// EXTERNAL MODULE: ./node_modules/react-phone-number-input/style.css
var style = __webpack_require__(15922);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Visibility.js
var Visibility = __webpack_require__(20067);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/VisibilityOff.js
var VisibilityOff = __webpack_require__(28270);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/Help.js
var Help = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js + 2 modules
var Tooltip = __webpack_require__(49161);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/PhoneInputIconContainer.tsx





function PhoneInputIconContainer(param) {
    var tooltipTitle = param.tooltipTitle, _icon = param.icon, icon = _icon === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {}) : _icon;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
        title: (0,CMSText/* prismicText */.yz)(tooltipTitle),
        placement: "top",
        children: icon
    }));
};

;// CONCATENATED MODULE: ./components/TextField/TextField.tsx















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: function(LayoutStyle) {
                return LayoutStyle.isMargin ? 0 : theme.spacing(2);
            }
        },
        label: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            paddingLeft: function(LayoutStyle) {
                return LayoutStyle.isLabelPaddingLeft ? theme.spacing(1.25) : theme.spacing(0.25);
            },
            marginBottom: theme.spacing(0.5)
        },
        inline: {
            display: 'inline'
        },
        inlineIcon: {
            verticalAlign: '-5%',
            height: 11,
            width: 11,
            marginRight: theme.spacing(0.5)
        },
        input: {
            display: 'block',
            padding: theme.spacing(1, 1.25),
            fontFamily: theme.typography.fontFamily,
            width: '100%',
            fontSize: 14,
            borderRadius: theme.spacing(0.75),
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight,
            WebkitAppearance: 'none',
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            },
            '&:disabled': {
                userSelect: 'none',
                cursor: 'not-allowed'
            },
            '& textarea': {
                fontFamily: theme.typography.fontFamily,
                color: theme.typography.body1.color,
                fontSize: 14
            },
            '&.PhoneInput': {
                border: 'none',
                padding: 0,
                backgroundColor: 'transparent'
            }
        },
        inputContainer: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.extraColors.greyLight,
            borderRadius: 9,
            '&.PhoneInputWithIcon': {
                justifyContent: 'space-between'
            },
            '&.input': {
                width: '100%'
            }
        },
        inputIcons: {
            width: 21,
            cursor: 'pointer',
            margin: '0 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        inputPhone: {
            display: 'flex',
            paddingLeft: theme.spacing(1),
            fontFamily: theme.typography.fontFamily,
            fontSize: 14,
            borderRadius: 6,
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight,
            WebkitAppearance: 'none',
            width: '100%',
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            },
            '& .PhoneInputInput': {
                padding: '8px 10px',
                background: 'transparent',
                border: 'none',
                fontSize: 14,
                fontFamily: theme.typography.fontFamily,
                borderRadius: 6
            }
        },
        inputPhoneWithTooltip: {
            width: 0,
            flexBasis: '100%'
        },
        select: {
            padding: 0,
            '& [class*=-control]': {
                backgroundColor: 'transparent',
                cursor: 'pointer',
                minHeight: 0,
                border: 0
            },
            '& [class*=-Input]': {
                marginTop: 0,
                marginBottom: 0,
                paddingTop: 0,
                paddingBottom: 0,
                lineHeight: 'normal'
            },
            '& [class*=-ValueContainer]': {
                padding: theme.spacing(1, 1.25)
            },
            '& [class*=-indicatorContainer]': {
                padding: theme.spacing(0.5, 1)
            }
        },
        valid: {
            borderColor: theme.palette.success.main
        },
        invalid: {
            borderColor: theme.palette.error.main
        },
        rootSuccessIcon: {
            position: 'relative'
        },
        inputSuccess: {
            position: 'absolute',
            bottom: 0,
            right: theme.spacing(1),
            color: theme.palette.success.main
        }
    });
});
var customStyles = {
    indicatorSeparator: function() {
        return {};
    },
    control: function(style) {
        return _objectSpread({}, style, {
            border: 'none',
            boxShadow: 'none'
        });
    },
    menu: function(provided) {
        return _objectSpread({}, provided, {
            zIndex: 9999,
            minWidth: '120px'
        });
    }
};
function TextField_TextField(props) {
    var className = props.className, label = props.label, name = props.name, multiline = props.multiline, rows = props.rows, rowsMax = props.rowsMax, textArea = props.textArea, placeholder = props.placeholder, required = props.required, value = props.value, onChange = props.onChange, onKeyPress = props.onKeyPress, maxLength = props.maxLength, onClick = props.onClick, disabled = props.disabled, options = props.options, select = props.select, testSelector = props.testSelector, type = props.type, isDisabled = props.isDisabled, min = props.min, max = props.max, autoComplete = props.autoComplete, _noMargin = props.noMargin, noMargin = _noMargin === void 0 ? false : _noMargin, _isSuccessIcon = props.isSuccessIcon, isSuccessIcon = _isSuccessIcon === void 0 ? false : _isSuccessIcon, _noLabelPaddingLeft = props.noLabelPaddingLeft, noLabelPaddingLeft = _noLabelPaddingLeft === void 0 ? false : _noLabelPaddingLeft, phoneInputInfosIcon = props.phoneInputInfosIcon;
    var LayoutStyle = {
        isMargin: noMargin,
        isLabelPaddingLeft: !noLabelPaddingLeft
    };
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles(LayoutStyle);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var defaultPhoneFlag = function() {
        var ref, ref1;
        var localeLanguage = (theme === null || theme === void 0 ? void 0 : (ref = theme.settings) === null || ref === void 0 ? void 0 : ref.defaultCountry) || (router === null || router === void 0 ? void 0 : (ref1 = router.locale) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
        if (localeLanguage === 'EN') {
            return 'GB';
        } else return localeLanguage;
    };
    var _obj;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('textField', className, classes.root, isSuccessIcon && classes.rootSuccessIcon),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (0,clsx_m/* default */.Z)('label', classes.label),
                htmlFor: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        typeof label === 'string' ? "".concat(label, " ").concat(required && !label.trim().endsWith('*') ? '*' : '') : label,
                        name === 'phone' && value && !(0,react_phone_number_input_min/* isPossiblePhoneNumber */.tm)(value) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                            in: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: 'span',
                                color: 'error',
                                className: (0,clsx_m/* default */.Z)(classes.label, classes.inline),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                                            className: classes.inlineIcon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t('texts:funnel:invalid_tel')
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            name === 'phone' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((_obj = {}, _defineProperty(_obj, classes.inputContainer, !!(phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle)), _defineProperty(_obj, "PhoneInputWithIcon", !!(phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle)), _obj)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_phone_number_input_min/* default */.ZP, {
                        id: name,
                        className: (0,clsx_m/* default */.Z)('input', classes.inputPhone, _defineProperty({}, classes.inputPhoneWithTooltip, !!(phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle))),
                        name: name,
                        placeholder: placeholder || '',
                        required: required,
                        value: value,
                        defaultCountry: defaultPhoneFlag(),
                        onChange: onChange,
                        disabled: disabled
                    }),
                    (phoneInputInfosIcon === null || phoneInputInfosIcon === void 0 ? void 0 : phoneInputInfosIcon.tooltipTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.inputIcons,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInputIconContainer, _objectSpread({}, phoneInputInfosIcon))
                    })
                ]
            }) : select ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                id: name,
                styles: customStyles,
                placeholder: placeholder || '',
                className: (0,clsx_m/* default */.Z)(testSelector, classes.select, classes.input),
                options: options,
                onChange: onChange,
                value: value,
                isMulti: false,
                getOptionValue: function(option) {
                    return option['code'];
                },
                getOptionLabel: function(option) {
                    return option['name'];
                },
                isDisabled: isDisabled
            }) : textArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                id: name,
                placeholder: placeholder || '',
                className: (0,clsx_m/* default */.Z)('input', classes.input),
                onChange: function(param) {
                    var target = param.target;
                    return onChange && onChange(target.value);
                },
                onKeyPress: function(param) {
                    var key = param.key;
                    return onKeyPress && onKeyPress(key);
                },
                value: value,
                multiline: multiline,
                rows: rows,
                rowsMax: rowsMax,
                autoComplete: autoComplete
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.inputContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: name,
                        type: (showPassword ? 'text' : type) || 'text',
                        className: (0,clsx_m/* default */.Z)('input', classes.input),
                        maxLength: maxLength || 256,
                        name: name,
                        onClick: onClick,
                        placeholder: placeholder || '',
                        required: !!required,
                        value: value,
                        onChange: function(param) {
                            var target = param.target;
                            return onChange && onChange(target.value);
                        },
                        onKeyPress: function(param) {
                            var key = param.key;
                            return onKeyPress && onKeyPress(key);
                        },
                        disabled: disabled,
                        min: min,
                        max: max,
                        autoComplete: autoComplete
                    }),
                    type === 'password' && (!showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {
                        className: classes.inputIcons,
                        onClick: function() {
                            return setShowPassword(function(show) {
                                return !show;
                            });
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {
                        className: classes.inputIcons,
                        onClick: function() {
                            return setShowPassword(function(show) {
                                return !show;
                            });
                        }
                    }))
                ]
            }),
            isSuccessIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)(classes.inputSuccess, 'input__icon--success'),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {})
            })
        ]
    }));
};


/***/ }),

/***/ 27915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_htmlSerializer; }
});

// UNUSED EXPORTS: slugify

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@prismicio/types/dist/value/richText.js
var richText = __webpack_require__(32716);
;// CONCATENATED MODULE: ./utils/linkResolver.tsx
var linkResolver = function(doc) {
    // URL for a page type
    if (doc.type === 'pages') {
        return "/".concat(doc.uid);
    }
    // Backup for all other types
    return '/';
};
/* harmony default export */ var utils_linkResolver = (linkResolver);

;// CONCATENATED MODULE: ./utils/htmlSerializer.tsx



var slugify = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var value = args.join(' ');
    return value.normalize('NFD') // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase().trim().replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-') // separator
    ;
};
// -- Function to add unique key to props
var propsWithUniqueKey = function propsWithUniqueKey(props, key) {
    return Object.assign(props || {}, {
        key: key
    });
};
// -- HTML Serializer
// This function will be used to change the way the HTML is loaded
var htmlSerializer = function htmlSerializer(type, element, content, children, key) {
    var ref, ref1;
    var props = {};
    var targetAttr = (element === null || element === void 0 ? void 0 : (ref = element.data) === null || ref === void 0 ? void 0 : ref.target) ? {
        target: element.data.target
    } : {};
    var relAttr = (element === null || element === void 0 ? void 0 : (ref1 = element.data) === null || ref1 === void 0 ? void 0 : ref1.target) ? {
        rel: 'noopener'
    } : {};
    switch(type){
        // Add an id to h2 tag
        case richText/* RichTextNodeType.heading2 */.M.heading2:
            props = {
                id: slugify(element.text)
            };
            return(/*#__PURE__*/ react.createElement('h2', propsWithUniqueKey(props, key), children));
        // Add a class to paragraph elements
        case richText/* RichTextNodeType.paragraph */.M.paragraph:
            props = {
                className: 'paragraph-class'
            };
            return(/*#__PURE__*/ react.createElement('p', propsWithUniqueKey(props, key), children));
        // Don't wrap images in a <p> tag
        case richText/* RichTextNodeType.image */.M.image:
            props = {
                src: element.url,
                alt: element.alt || ''
            };
            return(/*#__PURE__*/ react.createElement('img', propsWithUniqueKey(props, key)));
        // Add a class to hyperlinks
        case richText/* RichTextNodeType.hyperlink */.M.hyperlink:
            props = Object.assign({
                className: 'link-class',
                href: element.data.url || utils_linkResolver(element.data)
            }, targetAttr, relAttr);
            return(/*#__PURE__*/ react.createElement('a', propsWithUniqueKey(props, key), children));
        // Return null to stick with the default behavior
        default:
            return null;
    }
};
/* harmony default export */ var utils_htmlSerializer = (htmlSerializer);


/***/ })

}]);